import React from 'react';
import ForgotPasswordSentConfirmation from "../../components/forgot-password-section/ForgotPasswordSentConfirmation";

const ForgotPasswordSent = (props) => (
    <ForgotPasswordSentConfirmation {...props}/>
);

export default ForgotPasswordSent;